var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RMap, toPairs } from "../collections";
import { makeImmutable } from "../core";
import { ProductCategoryId, ProductTypeId, } from "../ordering";
import { singleton } from "tsyringe";
let AutomaticCrossSellingWeightsParser = class AutomaticCrossSellingWeightsParser {
    constructor() {
        makeImmutable(this);
    }
    parse(weights) {
        if (weights === null) {
            return RMap.empty();
        }
        return RMap.fromIterable(toPairs(weights).map(([categoryId, rawCategoryWeights]) => {
            const categoryWeights = RMap.fromIterable(toPairs(rawCategoryWeights).map(([productTypeId, weight]) => [
                new ProductTypeId(productTypeId),
                weight,
            ]));
            return [new ProductCategoryId(categoryId), categoryWeights];
        }));
    }
};
AutomaticCrossSellingWeightsParser = __decorate([
    singleton(),
    __metadata("design:paramtypes", [])
], AutomaticCrossSellingWeightsParser);
export { AutomaticCrossSellingWeightsParser };
